import { render, staticRenderFns } from "./ad_org.vue?vue&type=template&id=cf764146&scoped=true"
import script from "./ad_org.vue?vue&type=script&lang=js"
export * from "./ad_org.vue?vue&type=script&lang=js"
import style0 from "./ad_org.vue?vue&type=style&index=0&id=cf764146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf764146",
  null
  
)

export default component.exports